import styled from "styled-components";
import { COLORS } from "../../../../../../../../styles/constants.style";

export const ModalContainer = styled.div`
  .fields-wrapper {
    padding: 16px 16px 32px 16px;
  }

  .MuiGrid2-container {
    margin-top: 16px;
  }

  .fee-and-expense-label {
    border-top: 1px dashed ${COLORS.primary_light_blue};
    padding: 16px;
  }

  .po-details-wrapper {
    margin-bottom: 16px;
    padding: 16px 16px 32px 16px;
  }

  .po-details-header {
    font-weight: bold;
    margin: 8px 0;
  }

  .download-performa-invoice {
    display: flex;
    align-items: center;
    color: ${COLORS.primary_light_blue};
    cursor: pointer;
  }
  .download-icon {
    margin-right: 8px;
  }

  .activity-info {
    margin: 24px 0;
  }

  .warning-icon {
    margin-right: 8px;
  }
  .po-shortage-icon {
    margin-left: 8px;
  }
  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
  }
`;
